module.exports = __webpack_public_path__ + "img/apple-pay.2a683501.svg";